import React from "react";
import ProjectThumbnail from "../../components/ProjectThumbnail.jsx";
import { Link } from "react-router-dom";

const UXList = ({ uxList }) => {
  return (
    <div>
      <span className="ff-serif --fs-300 ">
        UX case studies covering the full research-to-prototype process: user
        interviews, wireframing, sitemap architecture, and high-fidelity
        prototyping in Figma.
      </span>
      <div className="flex proj-content">
        {uxList
          .filter((product) => product.type === "ux")
          .map((item) => (
            <ProjectThumbnail item={item} key={item.id} />
          ))}
      </div>
    </div>
  );
};

export default UXList;
